const type = 'OPEN_LIMIT_PROPOSAL';

const openLimitProposal = () => ({
  type,
});

export { type };
export default openLimitProposal;
